import {ActiveUserService, CEProtocol, CEConstructor, ListSpecType} from 'lionheartland';
import {HttpClient} from 'lionheartland';
import {EOConstraintService} from '../../core/constraint/eo-constraint';
import {SOGetConstraint} from '../../core/constraint/so-get-constraint';
import {RAPutConstraint} from './ra-put-constraint';
import {RAPostConstraint} from './ra-post-constraint';
import {RADeleteConstraint} from './ra-delete-constraint';
import {AbstractEntityCore} from 'lionheartland';
import {EntityCoreProtocol} from 'lionheartland';
import { CEConstraint } from "./ce-constraint"


export class ConstraintCoreBase extends AbstractEntityCore implements EntityCoreProtocol {

  type = 'constraint';
  title = 'Constraint';
  ceProtocol: CEConstructor = CEConstraint

  entityService: EOConstraintService;
  soGetClass = SOGetConstraint;
  soGet: SOGetConstraint;


  constructor(
    public activeUserService: ActiveUserService,
  ) {
    super(
      activeUserService,
      EOConstraintService,
      null,
    );
    this.adapters = [
      new RAPostConstraint(this),
      new RAPutConstraint(this),
      new RADeleteConstraint(this),
    ];
    this.resetSoGet()
    this.setDefaultAdapters();
    this.finalInit();
  }

  resetSoGet() {
    this.soGet = new SOGetConstraint();
    this.soGet.queryOptions.limit = this.limit;
  }


}